const getClearedPathname = (pathname) => {
  const regexEtraSlashes = /\/+/g;
  const regexpTrailingSlashes = /\/+$/;

  return pathname.replace(regexEtraSlashes, '/').replace(regexpTrailingSlashes, '');
};

export default getClearedPathname;
